<template>
  <section id="contact" class="pb-8">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">Contact us</h1>
              <h3 class="font-weight-light mt-3">
                If you are interested in our services please contact us by filling out the form below.
                We will be happy to answer your questions and schedule an interview to clarify any of your
                concerns.
              </h3>
              <h3 class="font-weight-light mt-3">
                Alternatively, you can also use the following contacts:
              </h3>
              <h3 class="font-weight-light">
                Email: <a href="mailto:info@bb-smile.net" target="_blank">info@bb-smile.net</a>
              </h3>
            </v-col>
            <v-col cols="12" sm="7">
              <v-form id="contact-form" ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                    id="from_name"
                    v-model="name"
                    :rules="nameRules"
                    label="Your name"
                    name="from_name"
                    required
                ></v-text-field>

                <v-text-field
                    id="reply_to"
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    name="reply_to"
                    required
                ></v-text-field>

                <v-textarea
                    id="message"
                    v-model="message"
                    :rules="messageRules"
                    label="Your message"
                    name="message"
                    required
                />

                <v-btn
                    :dark="valid"
                    :disabled="!valid"
                    block
                    class="mt-3"
                    color="primary"
                    rounded
                    @click="submit()"
                >
                  Send
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
    <v-snackbar
        v-model="snackbar.enabled"
        :color="snackbar.color"
        :value="true"
        absolute
        bottom
        color="#119DA4"
        rounded="pill"
        timeout="3000"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.enabled = false"
        >
          Chiudi
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

</style>

<script>
import emailjs from 'emailjs-com';

emailjs.init(process.env.VUE_APP_EMAIL_USER_ID)

export default {
  data: () => ({
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "Email address is required",
      (v) => /.+@.+\..+/.test(v) || "Inserisci una mail valida",
    ],
    message: "",
    messageRules: [
      (v) => !!v || "Message is required",
      (v) => (v && v.length >= 10) || "Insert text with more information",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: 'Email sent successfully',
      color: ''
    },
    sendEmail() {
      try {
        emailjs.sendForm(
            process.env.VUE_APP_EMAIL_SERVICE_ID,
            process.env.VUE_APP_EMAIL_TEMPLATE_ID,
            "#contact-form"
        )
      } catch (error) {
        console.log({error})
      } finally {
        this.$refs.form.reset()
        this.snackbar.enabled = true
      }
    }
  }),
  methods: {
    submit() {
      this.sendEmail()
    }
  }
};
</script>
